
export let countries_list = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Virgin Islands",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo Brazzaville",
  "Congo Kinshasa",
  "Costa Rica",
  "Côte D'Ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Faroe Island",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Gambia ",
  "Georgia",
  "Germany",
  "Ghana",
  "Gilbraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guam",
  "Guandeloupe",
  "Guatemala",
  "Guinea",
  "Guinea Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong SAR",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran ",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau SAR",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia ",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norway",
  "Nothern Mariana Islands",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territories",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "ReUnion",
  "Romania",
  "Russian",
  "Rwanda",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  // "Ukraine",
  "United Arab Emirates",
  "United Kingdom ",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
  ]
  
  export const countries_list_nl = [
    'Afghanistan',
    'Åland',
    'Albanië',
    'Algerije',
    'Amerikaanse Maagdeneilanden',
    'Amerikaans-Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua en Barbuda',
    'Argentinië',
    'Armenië',
    'Aruba',
    'Australië',
    'Azerbeidzjan',
    "Bahama's",
    'Bahrein',
    'Bangladesh',
    'Barbados',
    'België',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bonaire, Sint Eustatius en Saba',
    'Bosnië en Herzegovina',
    'Botswana',
    'Bouvet',
    'Brazilië',
    'Britse Maagdeneilanden',
    'Brits Indische Oceaanterritorium',
    'Brunei',
    'Bulgarije',
    'Burkina Faso',
    'Burundi',
    'Cambodja',
    'Canada',
    'Centraal-Afrikaanse Republiek',
    'Chili',
    'China',
    'Christmaseiland',
    'Cocoseilanden',
    'Colombia',
    'Comoren',
    'Congo-Brazzaville',
    'Congo-Kinshasa',
    'Cookeilanden',
    'Costa Rica',
    'Cuba',
    'Curaçao',
    'Cyprus',
    'Denemarken',
    'Djibouti',
    'Dominica',
    'Dominicaanse Republiek',
    'Duitsland',
    'Ecuador',
    'Egypte',
    'El Salvador',
    'Equatoriaal-Guinea',
    'Eritrea',
    'Estland',
    'Ethiopië',
    'Faeröer',
    'Falklandeilanden',
    'Fiji',
    'Filipijnen',
    'Finland',
    'Frankrijk',
    'Franse Zuidelijke en Antarctische Gebiede',
    'Frans-Guyana',
    'Frans-Polynesië',
    'Gabon',
    'Gambia',
    'Georgië',
    'Ghana',
    'Gibraltar',
    'Grenada',
    'Griekenland',
    'Groenland',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinee',
    'Guinee-Bissau',
    'Guyana',
    'Haïti',
    'Heard en McDonaldeilanden',
    'Honduras',
    'Hongarije',
    'Hongkong',
    'Ierland',
    'IJsland',
    'India',
    'Indonesië',
    'Irak',
    'Iran',
    'Israël',
    'Italië',
    'Ivoorkust',
    'Jamaica',
    'Japan',
    'Jemen',
    'Jersey',
    'Jordanië',
    'Kaaimaneilanden',
    'Kaapverdië',
    'Kameroen',
    'Kazachstan',
    'Kenia',
    'Kirgizië',
    'Kiribati',
    'Koeweit',
    'Kosovo',
    'Kroatië',
    'Laos',
    'Lesotho',
    'Letland',
    'Libanon',
    'Liberia',
    'Libië',
    'Liechtenstein',
    'Litouwen',
    'Luxemburg',
    'Macau',
    'Macedonië',
    'Madagaskar',
    'Malawi',
    'Maldiven',
    'Maleisië',
    'Mali',
    'Malta',
    'Man',
    'Marokko',
    'Marshalleilanden',
    'Martinique',
    'Mauritanië',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Micronesia',
    'Moldavië',
    'Monaco',
    'Mongolië',
    'Montenegro',
    'Montserrat',
    'Mozambique',
    'Myanmar',
    'Namibië',
    'Nauru',
    'Nederland',
    'Nepal',
    'Nicaragua',
    'Nieuw-Caledonië',
    'Nieuw-Zeeland',
    'Niger',
    'Nigeria',
    'Niue',
    'Noordelijke Marianen',
    'Noord-Korea',
    'Noorwegen',
    'Norfolk',
    'Oeganda',
    // 'Oekraïne',
    'Oezbekistan',
    'Oman',
    'Oostenrijk',
    'Oost-Timor',
    'Pakistan',
    'Palau',
    'Palestina',
    'Panama',
    'Papua-Nieuw-Guinea',
    'Paraguay',
    'Peru',
    'Pitcairneilanden',
    'Polen',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Réunion',
    'Roemenië',
    'Rusland',
    'Rwanda',
    'Saint-Barthélemy',
    'Saint Kitts en Nevis',
    'Saint Lucia',
    'Saint-Pierre en Miquelon',
    'Saint Vincent en de Grenadines',
    'Salomonseilanden',
    'Samoa',
    'San Marino',
    'Saoedi-Arabië',
    'Sao Tomé en Principe',
    'Senegal',
    'Servië',
    'Seychellen',
    'Sierra Leone',
    'Singapore',
    'Sint-Helena, Ascension en Tristan da Cunha',
    'Sint-Maarten',
    'Sint Maarten',
    'Slovenië',
    'Slowakije',
    'Soedan',
    'Somalië',
    'Spanje',
    'Spitsbergen en Jan Mayen',
    'Sri Lanka',
    'Suriname',
    'Swaziland',
    'Syrië',
    'Tadzjikistan',
    'Taiwan',
    'Tanzania',
    'Thailand',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad en Tobago',
    'Tsjaad',
    'Tsjechië',
    'Tunesië',
    'Turkije',
    'Turkmenistan',
    'Turks- en Caicoseilanden',
    'Tuvalu',
    'Uruguay',
    'Vanuatu',
    'Vaticaanstad',
    'Venezuela',
    'Verenigde Arabische Emiraten',
    'Verenigde Staten',
    'Verenigd Koninkrijk',
    'Vietnam',
    'Wallis en Futuna',
    'Westelijke Sahara',
    'Wit-Rusland',
    'Zambia',
    'Zimbabwe',
    'Zuid-Afrika',
    'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
    'Zuid-Korea',
    'Zuid-Soedan',
    'Zweden',
    'Zwitserland'
  ]
  
  export let countries_list_de = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "British Virgin Islands",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo Brazzaville",
    "Congo Kinshasa",
    "Costa Rica",
    "Côte D'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Faroe Island",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "Gabon",
    "Gambia ",
    "Georgia",
    "Germany",
    "Ghana",
    "Gilbraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guam",
    "Guandeloupe",
    "Guatemala",
    "Guinea",
    "Guinea Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hong Kong SAR",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran ",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau SAR",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia ",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Nothern Mariana Islands",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territories",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "ReUnion",
    "Romania",
    "Russian",
    "Rwanda",
    "Saint Helena",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    // "Ukraine",
    "United Arab Emirates",
    "United Kingdom ",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
    ]
